import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Skeleton,
  Grid,
} from "@mui/material";
const PostSkeleton = ({ count = 3 }) => {
  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      {[...Array(count)].map((_, index) => (
        <Card key={index} sx={{ mb: 4 }}>
          <CardHeader
            avatar={
              <Skeleton
                animation="wave"
                variant="circular"
                width={40}
                height={40}
              />
            }
            title={
              <Skeleton
                animation="wave"
                height={20}
                width="40%"
                style={{ marginBottom: 6 }}
              />
            }
            subheader={<Skeleton animation="wave" height={20} width="30%" />}
            action={
              <Box sx={{ display: "flex", gap: 1, p: 1 }}>
                <Skeleton animation="wave" height={36} width={100} />
                <Skeleton animation="wave" height={36} width={100} />
              </Box>
            }
          />

          <Grid container spacing={2}>
            {/* Text Content Skeleton */}
            <Grid size={6}>
              <CardContent>
                <Skeleton
                  animation="wave"
                  height={20}
                  style={{ marginBottom: 6 }}
                />
                <Skeleton
                  animation="wave"
                  height={20}
                  style={{ marginBottom: 6 }}
                />
                <Skeleton
                  animation="wave"
                  height={20}
                  style={{ marginBottom: 6 }}
                />
                <Skeleton
                  animation="wave"
                  height={20}
                  style={{ marginBottom: 6 }}
                />
                <Skeleton animation="wave" height={20} width="80%" />
              </CardContent>
            </Grid>

            {/* Image Skeleton */}
            <Grid size={6}>
              <Skeleton
                animation="wave"
                variant="rectangular"
                sx={{
                  height: 250,
                  m: 2,
                }}
              />
            </Grid>
          </Grid>
        </Card>
      ))}
    </Box>
  );
};

export default PostSkeleton;
